// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import colors from '../../styles/colors'
import zindex from '../../styles/zindex'
import { hideAlert } from '../../actions/alert'

const StyledAlert = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 25%;
  right: 25%;
  z-index: ${zindex.alert};
  padding: 10px 20px;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-weight: 300;
  background: ${(props) => colors[props.klass] || colors.danger};
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25), 0 0 1px rgba(0, 0, 0, 0.35);
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  transform: translate3d(0, 0, 0);
  transition: transform 0.3s cubic-bezier(0.2, 0.6, 0.2, 1);
`

const CloseButton = styled.button`
  color: #fff;
  background: transparent;
  cursor: pointer;
  border: 0;
  font-size: 20px;
  width: 30px;
`

type Props = {
  klass?: string,
  pathname: string,
  visible: boolean,
  message: string,
  hideAlert: Function,
  timeout?: number // eslint-disable-line
}

class Alert extends Component {
  constructor(props: Props) {
    super(props)
    this.state = {
      hidden: true
    }
  }

  state: { hidden: boolean }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.visible && nextProps.message !== this.props.message) {
      setTimeout(() => {
        this.setState({ hidden: false })
      })
    }
    if (nextProps.timeout) {
      setTimeout(this.handleClose, nextProps.timeout)
    }
    if (this.props.visible && this.props.pathname !== nextProps.pathname) {
      this.handleClose()
    }
  }

  props: Props

  handleClose = () => {
    this.setState({ hidden: true }, () => {
      setTimeout(() => this.props.hideAlert(), 300)
    })
  }

  render() {
    return this.props.visible ? (
      <StyledAlert
        klass={this.props.klass}
        style={{ transform: this.state.hidden && 'translate3d(0,-100%,0)' }}
      >
        <div style={{ width: '30px' }} />
        <div style={{ flexGrow: 1 }}>{this.props.message}</div>
        <CloseButton onClick={this.handleClose}>&times;</CloseButton>
      </StyledAlert>
    ) : null
  }
}

export default connect(
  (state) => ({
    klass: state.alert.klass,
    message: state.alert.message,
    visible: state.alert.visible,
    timeout: state.alert.timeout
  }),
  { hideAlert }
)(Alert)



// WEBPACK FOOTER //
// ./src/containers/Alert/index.js